import type { Question } from "../../types.js";
import type { Locale } from "./conceptCopy.js";
import { C1_SEED_QUESTIONS_ES } from "./seedLocaleEs.js";
import { AI_LITERACY_SEED_QUESTIONS_EL } from "./seedLocaleEl.js";

/**
 * Apply localized copy to seed MCQs.
 * - `es`: C.1 ids only (`p70`–`p99`, `pa0`) as authored in `seedLocaleEs.ts`
 * - `el`: full bank from `seedLocaleEl.ts`
 * - others: canonical `seed.ts`
 */
export function applyAiLiteracySeedLocale(question: Question, locale: Locale): Question {
  if (locale === "el") {
    const el = AI_LITERACY_SEED_QUESTIONS_EL[question.id];
    if (!el) return question;
    return { ...question, text: el.text, options: el.options };
  }
  if (locale === "es") {
    const es = C1_SEED_QUESTIONS_ES[question.id];
    if (!es) return question;
    return { ...question, text: es.text, options: es.options };
  }
  return question;
}
